import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Form} from 'forms/rrf';
import {Col, Row} from 'react-bootstrap';
import RequiredInput from '../../common/form/elements/required-input';
import RequiredRadioGroup from '../../common/form/elements/required-radio-group';
import ArrowButton from '../../common/button-arrow';
import {getLevels, saveLevel, updateLevel} from '../../../actions/levels';
import Select from '../../common/form/elements/select';

class EditLevelForm extends Component {
  state = {};

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };
  onSubmit = (payLoad) => {
    const {dispatch, level, edit} = this.props;

    if (edit) {
      dispatch(actions.submitFields('deep.admin_level', updateLevel(level.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_level', saveLevel(payLoad)));
    }
  };

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getLevels(true));
  }

  render() {
    const {
      edit, formValid, level, levels
    } = this.props;

    const levelValues = levels.filter(l => !(edit && level && `${l.id}` === `${level.id}`))
      .map(l => ({
        value: l.id,
        label: l.attributes.name
      }));

    const activeOptions = [
      {
        label: 'Active',
        value: 'true',
      },
      {
        label: 'Not Active',
        value: 'false',
        disabled: (edit && level && !level.attributes.inactivatable),
      }
    ];

    return (
      <Form model="deep.admin_level" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput
              label="Name"
              model=".name"
              placeholder="Name"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            Once the user has hit the points threshold of this level, we need to know what level they should move up to. If you leave this
            blank, the
            user will stay on this level
            <Select
              isEmptyDisabled={false}
              model=".next_level"
              values={levelValues}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            Set this level to active?*
            <RequiredRadioGroup
              controlId="admin_level_active"
              model=".active"
              radios={activeOptions}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              className="float-end"
              color="grey"
              disabled={!formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  level: state.level.level,
  levels: state.level.levels,
  fetched: state.level.fetched,
  fetching: state.level.fetching,
  formValid: state.deep.forms.admin_level.$form.valid,
});

export default connect(mapStateToProps)(EditLevelForm);
